<template>
  <b-card>
    <div slot="header">
      <b-button v-if="$route.params.serviceCode" :to="{name: 'app-list', params: {serviceCode: $route.params.serviceCode}}" size="sm" variant="link"><i class="fa fa-chevron-left" /></b-button>
      统计数据
    </div>
    <b-link :to="{name: 'tag-list'}" v-if="checkAdminType()">
      <b-button variant="outline-primary" :style="{marginBottom: '18px'}" >
        标签管理
      </b-button>
    </b-link>
    <b-card>
      <b-form>
        <b-form-group label="服务：" label-for="name">
          <el-select multiple class="mb-2" id="service_code" v-model="query.service_code" style="width:100%">
            <el-option v-for="service in services" :key="service.value" :label="service.text" :value="service.value" />
          </el-select>
        </b-form-group>
        <b-form-group label-for="product_code" label="产品：">
          <el-select multiple class="mb-2" filterable id="product_code" v-model="query.product_code" style="width:100%">
            <el-option v-for="product in products" :key="product.value" :label="product.text" :value="product.value" />
          </el-select>
        </b-form-group>
        <b-form-group label-for="app_code" label="实例：">
          <el-select multiple class="mb-2" id="app_code" v-model="query.app_code" style="width:100%">
            <el-option v-for="app in apps" :key="app.value" :label="app.text" :value="app.value" />
          </el-select>
        </b-form-group>
        <b-form-group label-for="tag" label="标签：">
          <b-form-checkbox-group name="tag" v-model="query.tags" :options="tagList">
          </b-form-checkbox-group>
        </b-form-group>
        <!--<b-form-group label-for="group" label="分组：">-->
          <!--<b-form-radio-group name="group" v-model="query.groups" :options="groupList"-->
                              <!--buttons button-variant="outline-secondary" @change="changeGroup">-->
          <!--</b-form-radio-group>-->
        <!--</b-form-group>-->
        <b-form-group label-for="start_time" label="时间范围:">
          <el-date-picker
            v-model="query.query_time"
            type="datetimerange"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="dateOptions"
          />
        </b-form-group>
        <a href="#" class="hidden" ref="download" />
        <b-button variant="outline-primary" :style="{marginBottom: '18px'}" @click="queryStat('query')">查询</b-button>
        <b-button variant="outline-danger" :style="{marginBottom: '18px'}" @click="queryStat('download')">下载</b-button>
      </b-form>
    </b-card>
    <b-card no-body v-for="(stats, tag) in items" :header="tagName(tag)" :key="tag">
      <stat-chart :data="stats" :fields="fields" />
      <b-table responsive="sm" :items="stats" :fields="tableFields">
      </b-table>
    </b-card>
  </b-card>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'
import utils from '@/utils/utils'
import StatChart from '@/components/StatChart'

export default {
  name: 'stat',
  mixins: [Error],
  components: {
    StatChart
  },
  props: {
    caption: {
      type: String,
      default: '统计数据'
    }
  },
  data: () => {
    return {
      query: {
        tags: [],
        groups: null,
        query_time: [],
        product_code: '',
        service_code: '',
        app_code: []
      },
      fields: {},
      tableFields: [],
      items: {},
      apps: [],
      products: [],
      services: [],
      tagList: [],
      groupList: [
        {'value': null, 'text': '无分组'}
      ],
      dateOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      }
    }
  },
  created () {
    this.fetchData()
    this.initDate()
    this.$nextTick(() => {
      if (this.$route.params.serviceCode) {
        this.query.service_code = [this.$route.params.serviceCode]
        this.query.product_code = [this.$route.query.productCode]
        this.query.app_code = [this.$route.params.appCode]
      }
    })
  },
  watch: {
    'query.service_code': {
      handler: function (val, newVal) {
        this.queryTag()
      }
    },
    'query.product_code': {
      handler: function (val, newVal) {
        this.queryTag()
      }
    },
    'query.app_code': {
      handler: function (val, newVal) {
        this.queryTag()
      }
    }
  },
  methods: {
    fetchData () {
      this.$ajax.all([
        this.$ajax.get(api.getTagList()), this.$ajax.get(api.getGroupList()),
        this.$ajax.get(api.getProductList()), this.$ajax.get(api.getServiceList())
      ]).then(([tagRes, groupRes, productRes, serviceRes]) => {
        tagRes.tags.forEach((tag) => {
          this.tagList.push({
            value: tag['tag'], text: tag['app_code'] + (tag['name'] || tag['tag'])
          })
        })
        groupRes.groups.forEach((group) => {
          this.groupList.push({
            value: group['_id'], text: group['name'], tags: group['tags']
          })
        })
        productRes.products.forEach((product) => {
          this.products.push({value: product.code, text: product.name})
        })
        serviceRes.services.forEach((service) => {
          this.services.push({value: service.code, text: service.name})
        })
      }, (res) => {
        this.handleError(res[0])
      })
    },
    queryStat (action) {
      if (!this.query.tags.length) {
        this.$message.warning('未勾选查询标签')
        return
      }
      let params = {
        action: action,
        tag: this.query.tags,
        start_time: this.query.query_time[0],
        end_time: this.query.query_time[1]
      }
      if (this.query.service_code) {
        params.service_code = this.query.service_code
      }
      if (this.query.product_code) {
        params.product_code = this.query.product_code
      }
      if (this.query.app_code) {
        params.app_code = this.query.app_code
      }
      this.$ajax.post(api.getQueryStat(), params).then((res) => {
        let fields = {
          'stat_date': '时间'
        }
        let tableFields = [{
          stat_date: '时间'
        }]
        this.items = {}
        Object.keys(res.result).map((tag) => {
          let dateMap = {}
          res.result[tag].map((s) => {
            if (Object.keys(dateMap).indexOf(s['stat_date']) === -1) {
              dateMap[s['stat_date']] = {stat_date: s['stat_date']}
            }
            dateMap[s['stat_date']][s['app_code']] = s['count']
            fields[s['app_code']] = this.appName(s['app_code'])
            let tmp = {}
            tmp[s['app_code']] = this.appName(s['app_code'])
            tableFields.push(tmp)
          })
          this.$set(this.items, tag, Object.keys(dateMap).map((date) => {
            return dateMap[date]
          }))
        })
        this.fields = fields
        this.tableFields = tableFields
      }, (res) => {
        if (action === 'download') {
          if (res.response && res.response.status !== 200) {
            this.$message.error('导出失败')
          } else {
            this.$refs.download.href = window.URL.createObjectURL(new Blob(
              [res.data], {type: res.headers['content-type']}
            ))
            this.$refs.download.download = 'data.txt'
            this.$refs.download.click()
          }
        } else {
          this.handleError(res)
        }
      })
    },
    changeGroup (val) {
      let group = utils.findInArray(this.groupList, val, 'tags', 'value')
      if (group) {
        this.query.tags = group
      } else {
        this.query.tags = []
      }
    },
    queryTag () {
      let params = {
        product_code: this.query.product_code,
        service_code: this.query.service_code,
        app_code: this.query.app_code
      }
      if (this.query.service_code.length) {
        this.$ajax.all([
          this.$ajax.post(api.getTagList(), params),
          this.$ajax.get(api.getAppList(this.query.service_code))
        ]).then(([tagRes, appRes]) => {
          this.tagList = []
          tagRes.tags.forEach((tag) => {
            this.tagList.push({
              value: tag['tag'], text: tag['app_code'] + (tag['name'] || tag['tag'])
            })
          })
          this.apps = []
          appRes.apps.forEach((app) => {
            if (!this.query.product_code.length || this.query.product_code.indexOf(app['product_code']) !== -1) {
              this.apps.push({
                value: app['code'], text: app['name']
              })
            }
          })
        }, (res) => {
          this.handleError(res)
        })
      } else {
        this.$ajax.post(api.getTagList(), params).then((tagRes) => {
          this.tagList = []
          tagRes.tags.forEach((tag) => {
            this.tagList.push({
              value: tag['tag'], text: tag['app_code'] + (tag['name'] || tag['tag'])
            })
          })
          this.apps = []
        }, (res) => {
          this.handleError(res)
        })
      }
    },
    tagName (tag) {
      return utils.findInArray(this.tagList, tag, 'text', 'value') || tag
    },
    appName (app) {
      return utils.findInArray(this.apps, app, 'text', 'value') || app
    },
    initDate () {
      let start = new Date()
      let end = new Date()
      start.setTime(new Date() - 3600 * 1000 * 24 * 7)
      this.query.query_time = [
        start.getFullYear() + '-' + (start.getMonth() + 1) + '-' + start.getDate() + ' ' + start.getHours() + ':' + start.getMinutes() + ':' + start.getSeconds(),
        end.getFullYear() + '-' + (end.getMonth() + 1) + '-' + end.getDate() + ' ' + end.getHours() + ':' + end.getMinutes() + ':' + end.getSeconds()
      ]
    },
    checkAdminType () {
      return utils.checkAdminType('super', this.$store.getters.loginInfo)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Stat.vue?1a2e7d42